import { render } from "./SalesView.vue?vue&type=template&id=6021daf8&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"

import "./SalesView.vue?vue&type=style&index=0&id=6021daf8&lang=css"
import "./SalesView.vue?vue&type=style&index=1&id=6021daf8&scoped=true&lang=css"

import exportComponent from "/Users/dmitrii.verov/website/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6021daf8"]])

export default __exports__